// React Libraries
import React from 'react'
// import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next'

import styled from '@emotion/styled'
const Wrapper = styled.div`
  //position: absolute;
  //padding-bottom: inherit;
  padding-left: inherit;
  padding-right: inherit;
  text-align: center;
  justify-self: flex-end;
  white-space: pre-wrap;
  left: 0;
  right: 0;
  bottom: 0.45in;
  //height: 3cm;
  //background: green;
  //z-index: -1;
  @media print {
    //height: 1cm;
    //margin-bottom: 0.55in;
    position: fixed;
    //background: blue;
  }
`

// eslint-disable-next-line no-unused-vars
const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${(props) =>
    props.left &&
    `
    align-items: flex-start;
    text-align: left;
  `} ${(props) =>
    props.right &&
    `
      text-align: right;
      align-items: flex-end;
  `};
`

// Component
function Footer({ t, invoice, invoiceSettings, company }) {
  return (
    <Wrapper>
      <p>{invoice.footer}</p>

      {invoiceSettings.companyInformationPosition === 'bottom' && (
        <div className='company-information bottom'>
          <div>
            <p className='label company-name'>{company.name}</p>
            {company.address && (
              <p>
                {company.address.line1} <br />
                {company.address.line2 && company.address.line2 + '\n'}
                {company.address.postalCode} {company.address.city}
              </p>
            )}
          </div>
          <div>
            {(company.phone || company.website || company.email) && (
              <p className={'contact-information'}>
                {company.phone && (
                  <React.Fragment>
                    <span className='label'>TEL</span>
                    {company.phone + '\n'}
                  </React.Fragment>
                )}
                {company.email && (
                  <React.Fragment>
                    <span className='label'>EMAIL</span>
                    {company.email + '\n'}
                  </React.Fragment>
                )}
                {company.website && (
                  <React.Fragment>
                    <span className='label'>WEB</span>
                    {company.website + '\n'}
                  </React.Fragment>
                )}
              </p>
            )}
          </div>
          <div>
            <p>
              {company.companyRegistrationNumber && (
                <React.Fragment>
                  <span className='label'>{t('kvkNumber')}</span>
                  {company.companyRegistrationNumber}
                  <br />
                </React.Fragment>
              )}
              {company.vatIdentificationNumber && (
                <React.Fragment>
                  <span className='label'>
                    {t('vatNumber')}
                  </span>
                  {company.vatIdentificationNumber}
                  <br />
                </React.Fragment>
              )}
              {company.bankAccountNumber && (
                <React.Fragment>
                  <span className="label">{t('bankAccount')}</span>
                  {company.bankAccountNumber}
                  <br />
                </React.Fragment>
              )}
            </p>
          </div>
        </div>
      )}
    </Wrapper>
  )
}

// Footer.propTypes = {
//   configs: PropTypes.object.isRequired,
//   invoice: PropTypes.object.isRequired,
//   company: PropTypes.object.isRequired,
//   t: PropTypes.func.isRequired,
// };

export default withTranslation()(Footer)
